<template>
    <!-- new layout -->
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" :to="'/assets/' + client.key + '/' + site.key">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="'/sites/' + client.key"> {{ client.name }} </router-link> /
                        <router-link :to="'/site/' + client.key + '/' + site.key"> {{ site.name }} </router-link> /
                        <span class="p-pr-1"> #{{ asset.asset_id }}</span>
                    </span>
                </h4>
                <div class="detail_wrapper p-mt-2 p-mb-6">
                    <AssetDetails v-if="asset.asset_type == 'Asset'" />
                    <LocationDetails v-else />

                    <div class="p-col">
                        <div class="asset-links p-pl-0 p-pl-lg-12">
                            <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/asset-documents/' + client.key + '/' + asset.site_id + '/' + asset.key">
                                <span class="p-d-flex p-jc-between p-ai-center">
                                    <i class="pi pi-file" />
                                    Documents
                                </span>
                                <i class="pi pi-angle-right" /></router-link>
                            <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/asset-certificates/' + client.key + '/' + asset.site_id + '/' + asset.key">
                                <span class="p-d-flex p-jc-between p-ai-center">
                                    <i class="pi pi-thumbs-up"></i>
                                    Certificates
                                </span>
                                <i class="pi pi-angle-right" /></router-link>
                            <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/asset-notes/' + client.key + '/' + asset.site_id + '/' + asset.key">
                                <span class="p-d-flex p-jc-between p-ai-center">
                                    <i class="pi pi-pencil" />
                                    Notes
                                </span>
                                <i class="pi pi-angle-right" /></router-link>
                            <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/asset-activity-log/' + client.key + '/' + asset.site_id + '/' + asset.key">
                                <span class="p-d-flex p-jc-between p-ai-center">
                                    <i class="pi pi-list" />
                                    Activity Log
                                </span>
                                <i class="pi pi-angle-right" /></router-link>
                            <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/fault-log/' + client.key + '/' + asset.site_id + '/' + asset.key">
                                <span class="p-d-flex p-jc-between p-ai-center">
                                    <i class="pi pi-exclamation-triangle" />
                                    Fault Log
                                </span>
                                <i class="pi pi-angle-right" /></router-link>
                            <!-- <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/asset-fault-log/' + client.key + '/' + asset.site_id + '/' + asset.key">
                                <span class="p-d-flex p-jc-between p-ai-center">
                                    <i class="pi pi-list" />
                                    Fault Log
                                </span>
                                <i class="pi pi-angle-right" /></router-link> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import { db } from '@/firebase';
import { mapGetters } from "vuex";
import AssetDetails from '../components/AssetDetails.vue';
import LocationDetails from '../components/LocationDetails.vue';

export default {
    components: {
        AssetDetails,
        LocationDetails
    },
    data() {
        return {
            client: {},
            site: {},
            asset: {},
            assetDocuments: [],
            assetNotes: [],
        }
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.$route.params.client_id),
            asset: db.collection('assets').doc(this.$route.params.id),
            site: db.collection('sites').doc(this.$route.params.site_id),
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
}
</script>
